module.exports = __webpack_public_path__ + "build/img/cry.398d9793.png";